import React from "react";
import {
  classeSituacao,
  iconeTipoEvento,
  textoDiasRestantes,
  textoObjeto,
} from "../utils/eventoListaUtil";

interface Props {
  evento: any;
  onAcessar: (evento: any) => void;
  onCompartilhar: (evento: any, e: React.MouseEvent) => void;
}

export default function EventoResultadoItem({
  evento,
  onAcessar,
  onCompartilhar,
}: Props) {
  const situacaoClasse = classeSituacao(evento.situacao);
  const objeto = textoObjeto(evento.descricao);
  const dias = textoDiasRestantes(evento.periodoValidade, evento.situacao);

  return (
    <article
      className={`ce-card ce-card--${situacaoClasse}`}
      onClick={() => onAcessar(evento)}
    >
      <div className="ce-card-col ce-card-col--evento">
        <i className={`pi ${iconeTipoEvento(evento.tipoEvento)}`} />
        <span className="ce-card-tipo">{evento.tipoEvento}</span>
        <strong className="ce-card-numero">{evento.numero}</strong>
      </div>
      <div className="ce-card-col ce-card-col--objeto" title={objeto}>
        <p>{objeto || "Sem objeto informado."}</p>
      </div>
      <div className="ce-card-col ce-card-col--situacao">
        <span className={`ce-badge ce-badge--${situacaoClasse}`}>
          {evento.situacao}
        </span>
        {evento.periodoValidade && (
          <span className="ce-card-periodo">{evento.periodoValidade}</span>
        )}
        {dias && <span className="ce-card-dias">{dias}</span>}
      </div>
      <div className="ce-card-col ce-card-col--acoes">
        <button
          type="button"
          className="ce-acao ce-acao--primaria"
          onClick={(e) => {
            e.stopPropagation();
            onAcessar(evento);
          }}
        >
          <span className="ce-acao-icone">
            <i className="pi pi-search" />
          </span>
          <span className="ce-acao-label">Acessar Evento</span>
        </button>
        <button
          type="button"
          className="ce-acao ce-acao--secundaria"
          onClick={(e) => {
            e.stopPropagation();
            onCompartilhar(evento, e);
          }}
        >
          <span className="ce-acao-icone">
            <i className="pi pi-share-alt" />
          </span>
          <span className="ce-acao-label">Compartilhar</span>
        </button>
      </div>
    </article>
  );
}
